export const data = [
    {
        BusNo: "ABC1213",
        BusName: "Inter City Commercial Bus",
        Source: "Faridabad (HR)",
        Destination: "Gwalior (M.P)",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC1123",
        BusName: "Inter City  Bus",
        Source: "Faridabad (HR)",
        Destination: "Gwalior (M.P)",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC1223",
        BusName: "Inter City Express Bus",
        Source: "Faridabad (HR)",
        Destination: "Gwalior (M.P)",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC2123",
        BusName: "Inter City Double Bus",
        Source: "Faridabad (HR)",
        Destination: "Gwalior (M.P)",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC1234",
        BusName: "Taj Express Bus",
        Source: "Faridabad (HR)",
        Destination: "Gwalior (M.P)",
        Date: "2023-04-11",
        DepartureTime: "11:00 AM",
        ArrivalTime: "18:00 PM",
        Fare: "260",
    },
    {
        BusNo: "DEF456",
        BusName: "Inter City Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "GHI789",
        BusName: "Inter Express Bus",
        Source: "Gwalior (M.P)",
        Destination: "Surat (Gujrat)",
        Date: "2023-03-31",
        DepartureTime: "8:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "300",
    },
    {
        BusNo: "JKL012",
        BusName: "Inter City Bus",
        Source: "Surat (Gujrat)",
        Destination: "Gwalior (M.P)",
        Date: "2023-03-31",
        DepartureTime: "1:00 PM",
        ArrivalTime: "5:00 PM",
        Fare: "350",
    },
    {
        BusNo: "DEF45",
        BusName: "Taj Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "DEF46",
        BusName: "Jhelum City Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "215",
    },
    {
        BusNo: "DEF56",
        BusName: "Govinda Express Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "400",
    },
    {
        BusNo: "DEF457",
        BusName: "Inter City Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "253",
    },
    {
        BusNo: "DEF458",
        BusName: "Inter City Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "25",
    },
    {
        BusNo: "DEF459",
        BusName: "Inter City Bus",
        Source: "Gwalior (M.P)",
        Destination: "Faridabad (HR)",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "258",
    },








    {
        BusNo: "ABC1234",
        BusName: "Inter City Commercial Bus",
        Source: "New Delhi",
        Destination: "Rajasthan",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC12344",
        BusName: "Inter City Bus",
        Source: "New Delhi",
        Destination: "Rajasthan",
        Date: "2023-04-11",
        DepartureTime: "11:00 AM",
        ArrivalTime: "18:00 PM",
        Fare: "260",
    },
    {
        BusNo: "DEF4564",
        BusName: "Inter City Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "GHI7894",
        BusName: "Inter Express Bus",
        Source: "Rajasthan",
        Destination: "Surat (Gujrat)",
        Date: "2023-03-31",
        DepartureTime: "8:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "300",
    },
    {
        BusNo: "JKL0124",
        BusName: "Inter City Bus",
        Source: "Surat (Gujrat)",
        Destination: "Rajasthan",
        Date: "2023-03-31",
        DepartureTime: "1:00 PM",
        ArrivalTime: "5:00 PM",
        Fare: "350",
    },
    {
        BusNo: "DEF454",
        BusName: "Taj Express Bus",
        Source: "Rajasthan",
        Destination: "Uttrakhand",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "DEF464",
        BusName: "Jhelum City Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "215",
    },
    {
        BusNo: "DEF564",
        BusName: "Govinda Express Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "400",
    },
    {
        BusNo: "DEF4574",
        BusName: "Inter City Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "253",
    },
    {
        BusNo: "DEF4584",
        BusName: "Inter City Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "25",
    },
    {
        BusNo: "DEF4594",
        BusName: "Inter Express City Bus",
        Source: "Rajasthan",
        Destination: "New Delhi",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "258",
    },

    {
        BusNo: "ABC12349",
        BusName: "Inter City Commercial Bus",
        Source: "Faridabad (HR)",
        Destination: "Surat (Gujrat)",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC12349",
        BusName: "Inter City Commercial Bus",
        Source: "Faridabad (HR)",
        Destination: "Surat (Gujrat)",
        Date: "2023-04-11",
        DepartureTime: "10:30 AM",
        ArrivalTime: "12:00 PM",
        Fare: "285",
    },


    {
        BusNo: "ABC12349",
        BusName: "Inter City Commercial Bus",
        Source: "Goa",
        Destination: "Jharkhand",
        Date: "2023-04-11",
        DepartureTime: "10:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "205",
    },
    {
        BusNo: "ABC123449",
        BusName: "Inter City Bus",
        Source: "Goa",
        Destination: "Jharkhand",
        Date: "2023-04-11",
        DepartureTime: "11:00 AM",
        ArrivalTime: "18:00 PM",
        Fare: "260",
    },
    {
        BusNo: "DEF45649",
        BusName: "Inter City Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "GHI78949",
        BusName: "Inter Express Bus",
        Source: "Jharkhand",
        Destination: "Surat (Gujrat)",
        Date: "2023-03-31",
        DepartureTime: "8:00 AM",
        ArrivalTime: "12:00 PM",
        Fare: "300",
    },
    {
        BusNo: "JKL01249",
        BusName: "Inter City Bus",
        Source: "Surat (Gujrat)",
        Destination: "Jharkhand",
        Date: "2023-03-31",
        DepartureTime: "1:00 PM",
        ArrivalTime: "5:00 PM",
        Fare: "350",
    },
    {
        BusNo: "DEF4549",
        BusName: "Taj Express Bus",
        Source: "Jharkhand",
        Destination: "Uttrakhand",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "250",
    },
    {
        BusNo: "DEF4649",
        BusName: "Jhelum City Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "215",
    },
    {
        BusNo: "DEF5649",
        BusName: "Govinda Express Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "400",
    },
    {
        BusNo: "DEF45749",
        BusName: "Inter City Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "253",
    },
    {
        BusNo: "DEF45849",
        BusName: "Inter City Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "254",
    },
    {
        BusNo: "DEF45949",
        BusName: "Inter Express City Bus",
        Source: "Jharkhand",
        Destination: "Goa",
        Date: "2023-04-11",
        DepartureTime: "1:00 PM",
        ArrivalTime: "3:00 PM",
        Fare: "258",
    },


];
